/* import __COLOCATED_TEMPLATE__ from './content-wrapper.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './content-wrapper.module.scss';

@classic
@classNames(styles.component)
export default class PracticeWebsiteContentWrapper extends Component {}
